export const SET_FILE = (id) => {
  return {
    type: 'SET_FILE',
    payload: { _id: id }
  }
}